const parseMenteeKey = (
  key: string
) => {
  const match = key.match(/MenteeDTO{id=([^,]+), firstName='([^']+)', lastName='([^']+)', avatar\(Base64\)='([^']+)', extension=([^}]+)}/) || ''

  return {
    id: match[1],
    firstName: match[2],
    lastName: match[3],
    avatar: match[4] === "null" ? "" : match[4],
    extension: match[5] === "null" ? "" : match[5]
  }
}

export default parseMenteeKey